import type { LucideProps } from "lucide-react";

import {
  CalendarClock,
  Download,
  GraduationCap,
  Handshake,
  KeyRound,
  LockOpen,
  PackageOpen,
  Repeat,
  Shirt,
} from "lucide-react";

interface ProductTypeOption {
  value: string;
  title: string;
  label: string;
  description: string;
  icon: React.ComponentType<LucideProps>;
  color: string;
}

export const PRODUCT_TYPE_OPTIONS: ProductTypeOption[] = [
  {
    value: "DIGITAL",
    title: "Digital Download",
    label: "Digital Download",
    description:
      "PDFs, templates, presets, design files, or any downloadable content.",
    icon: Download,
    color: "pink",
  },
  {
    value: "PHYSICAL",
    title: "Physical Product",
    label: "Physical Product",
    description: "Tangible goods you ship to customers.",
    icon: Shirt,
    color: "violet",
  },
  {
    value: "SERVICE",
    title: "Service",
    label: "Service",
    description: "Consulting, coaching, freelance work, or local services.",
    icon: Handshake,
    color: "lime",
  },
  {
    value: "DIGITAL",
    title: "License or Access Code",
    label: "License or Access Code",
    description: "Software keys, discount codes, or unlock credentials.",
    icon: KeyRound,
    color: "orange",
  },
  {
    value: "SOFTWARE",
    title: "Software",
    label: "Software",
    description: "Apps, tools, or subscriptions with recurring billing.",
    icon: Repeat,
    color: "teal",
  },
  {
    value: "EVENT",
    title: "Event or Experience",
    label: "Event or Experience",
    description: "Tickets to workshops, webinars, live events, or experiences.",
    icon: CalendarClock,
    color: "sky",
  },
  {
    value: "MEMBERSHIP",
    title: "Membership",
    label: "Membership",
    description:
      "Gated communities, exclusive content, or subscriber-only access.",
    icon: LockOpen,
    color: "fuchsia",
  },
  {
    value: "COURSE",
    title: "Online Course",
    label: "Online Course",
    description: "Video lessons, training programs, or educational content.",
    icon: GraduationCap,
    color: "yellow",
  },
  {
    value: "RETAIL",
    title: "Something Else",
    label: "Something Else",
    description: "Anything that doesn't fit the categories above.",
    icon: PackageOpen,
    color: "neutral",
  },
];
